/**
 * Furballly · 福宝风物志 — theme JavaScript
 * Vanilla JS only. No third-party dependencies.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    initAccountJourney();
    initBackToTop();
    initQuantitySteppers();
    initProductCardForms();
    initProductPageForms();
    initSetBuilders();
  });

  /* ---------- Customer account journey ---------- */
  function initAccountJourney() {
    var accountLinks = document.querySelectorAll('[data-account-entry]');
    var toast = document.querySelector('[data-account-status-toast]');
    var storageKey = 'furballly-account-login-started';

    accountLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        if (link.dataset.accountState !== 'signed-out') return;

        try {
          window.sessionStorage.setItem(storageKey, 'true');
        } catch (error) {
          // Login still works when browser storage is unavailable.
        }
      });
    });

    if (!toast) return;

    var loginStarted = false;
    try {
      loginStarted = window.sessionStorage.getItem(storageKey) === 'true';
      if (loginStarted) window.sessionStorage.removeItem(storageKey);
    } catch (error) {
      return;
    }

    if (!loginStarted) return;

    var closeButton = toast.querySelector('[data-account-status-close]');
    var hideToast = function () {
      toast.classList.remove('is-visible');
      window.setTimeout(function () { toast.hidden = true; }, 200);
    };

    toast.hidden = false;
    window.requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    if (closeButton) closeButton.addEventListener('click', hideToast);
    window.setTimeout(hideToast, 6000);
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var openBtn = document.querySelector('[data-menu-toggle]');
    var closeBtn = document.querySelector('[data-menu-close]');
    var menu = document.getElementById('MobileMenu');
    if (!openBtn || !menu) return;

    function toggle(open) {
      menu.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }

    openBtn.addEventListener('click', function () { toggle(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { toggle(false); });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) toggle(false);
    });

    // Close after tapping a nav link
    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { toggle(false); });
    });
  }

  /* ---------- Back to top ---------- */
  function initBackToTop() {
    var btn = document.querySelector('[data-back-to-top]');
    if (!btn) return;

    var onScroll = function () {
      btn.classList.toggle('is-visible', window.scrollY > 480);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---------- Quantity steppers (cart page) ---------- */
  function initQuantitySteppers() {
    document.querySelectorAll('.quantity-field').forEach(function (field) {
      var input = field.querySelector('input[type="number"]');
      var minus = field.querySelector('[data-quantity-minus]');
      var plus = field.querySelector('[data-quantity-plus]');
      if (!input) return;

      minus && minus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, v - 1);
        emitChange(input);
      });

      plus && plus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
        emitChange(input);
      });

      input.addEventListener('change', function () {
        if (parseInt(input.value, 10) < 1) input.value = 1;
      });
    });
  }

  function emitChange(input) {
    // Trigger the change event so cart line update listeners can react
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ---------- Product card actions ---------- */
  var productCache = {};
  var variantPickerState = {
    form: null,
    submitter: null,
    buyNow: false,
    selectedVariant: null
  };

  function initProductCardForms() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.matches('[data-product-card-form]')) return;

      var submitter = event.submitter || form.querySelector('[data-card-add]');
      if (!submitter || (!submitter.hasAttribute('data-card-add') && !submitter.hasAttribute('data-card-buy-now'))) return;

      event.preventDefault();
      var buyNow = submitter.hasAttribute('data-card-buy-now');

      if (form.dataset.requiresOptions === 'true') {
        openVariantPicker(form, submitter, buyNow);
        return;
      }

      submitProductCardAction(form, submitter, buyNow);
    });
  }

  /* ---------- Product page buy now ---------- */
  function initProductPageForms() {
    document.querySelectorAll('[data-product-page-form]').forEach(function (form) {
      var buyNowButton = form.querySelector('[data-product-buy-now]');
      if (!buyNowButton) return;

      buyNowButton.addEventListener('click', function () {
        var buttons = Array.from(form.querySelectorAll('.product-form__button'));
        var disabledStates = buttons.map(function (button) { return button.disabled; });
        var originalLabel = buyNowButton.textContent.trim();

        buttons.forEach(function (button) { button.disabled = true; });
        buyNowButton.textContent = buyNowButton.dataset.loadingLabel;

        fetch(form.action + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
          credentials: 'same-origin'
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Unable to add product to cart');
            window.location.assign(form.dataset.checkoutUrl);
          })
          .catch(function (error) {
            console.error(error);
            buyNowButton.textContent = buyNowButton.dataset.errorLabel;
            window.setTimeout(function () {
              buyNowButton.textContent = originalLabel;
            }, 2000);

            buttons.forEach(function (button, index) {
              button.disabled = disabledStates[index];
            });
          });
      });
    });
  }

  function submitProductCardAction(form, submitter, buyNow) {
    var buttons = form.querySelectorAll('button[type="submit"]');
    var originalLabel = submitter.textContent.trim();

    buttons.forEach(function (button) { button.disabled = true; });
    submitter.textContent = submitter.dataset.loadingLabel;

    fetch(form.action + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add product to cart');
        return response.json();
      })
      .then(function () {
        if (buyNow) {
          window.location.assign(form.dataset.checkoutUrl);
          return null;
        }

        return fetch(form.dataset.cartUrl, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
      })
      .then(function (response) {
        if (!response) return null;
        if (!response.ok) throw new Error('Unable to refresh cart');
        return response.json();
      })
      .then(function (cart) {
        if (!cart) return;
        updateCartCount(cart.item_count);
        submitter.textContent = submitter.dataset.successLabel;
        window.setTimeout(function () {
          submitter.textContent = originalLabel;
        }, 1600);
      })
      .catch(function (error) {
        console.error(error);
        submitter.textContent = submitter.dataset.errorLabel;
        window.setTimeout(function () {
          submitter.textContent = originalLabel;
        }, 2000);
      })
      .finally(function () {
        buttons.forEach(function (button) { button.disabled = false; });
      });
  }

  function openVariantPicker(form, submitter, buyNow) {
    var modal = getVariantPicker();
    var fields = modal.querySelector('[data-variant-fields]');
    var confirmButton = modal.querySelector('[data-variant-confirm]');
    var status = modal.querySelector('[data-variant-status]');

    variantPickerState.form = form;
    variantPickerState.submitter = submitter;
    variantPickerState.buyNow = buyNow;
    variantPickerState.selectedVariant = null;

    modal.querySelector('[data-variant-title]').textContent = form.dataset.productTitle;
    modal.querySelector('[data-variant-intro]').textContent = form.dataset.optionsLabel;
    modal.querySelector('[data-variant-close]').setAttribute('aria-label', form.dataset.closeLabel);
    modal.querySelector('[data-variant-cancel]').textContent = form.dataset.cancelLabel;
    confirmButton.textContent = submitter.textContent.trim();
    confirmButton.disabled = true;
    fields.replaceChildren();
    status.textContent = form.dataset.loadingOptionsLabel;

    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }

    getProductData(form.dataset.productUrl)
      .then(function (product) {
        renderVariantOptions(product, form, modal);
      })
      .catch(function (error) {
        console.error(error);
        status.textContent = form.dataset.optionsErrorLabel;
      });
  }

  function getVariantPicker() {
    var existing = document.querySelector('[data-variant-modal]');
    if (existing) return existing;

    var modal = document.createElement('dialog');
    modal.className = 'variant-modal';
    modal.setAttribute('data-variant-modal', '');
    modal.setAttribute('aria-labelledby', 'VariantPickerTitle');
    modal.innerHTML =
      '<div class="variant-modal__panel">' +
        '<div class="variant-modal__head">' +
          '<div>' +
            '<h2 id="VariantPickerTitle" class="variant-modal__title" data-variant-title></h2>' +
            '<p class="variant-modal__intro" data-variant-intro></p>' +
          '</div>' +
          '<button type="button" class="variant-modal__close" data-variant-close>×</button>' +
        '</div>' +
        '<div class="variant-modal__fields" data-variant-fields></div>' +
        '<p class="variant-modal__status" data-variant-status aria-live="polite"></p>' +
        '<div class="variant-modal__actions">' +
          '<button type="button" class="btn btn--small" data-variant-cancel></button>' +
          '<button type="button" class="btn btn--solid btn--small" data-variant-confirm disabled></button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(modal);

    modal.querySelectorAll('[data-variant-close], [data-variant-cancel]').forEach(function (button) {
      button.addEventListener('click', function () { closeVariantPicker(modal); });
    });

    modal.querySelector('[data-variant-confirm]').addEventListener('click', function () {
      if (!variantPickerState.selectedVariant) return;

      var form = variantPickerState.form;
      var submitter = variantPickerState.submitter;
      var buyNow = variantPickerState.buyNow;
      form.querySelector('input[name="id"]').value = variantPickerState.selectedVariant.id;
      closeVariantPicker(modal);
      submitProductCardAction(form, submitter, buyNow);
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeVariantPicker(modal);
    });

    modal.addEventListener('close', function () {
      if (variantPickerState.submitter) variantPickerState.submitter.focus();
    });

    return modal;
  }

  function closeVariantPicker(modal) {
    if (typeof modal.close === 'function') {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }
  }

  function getProductData(productUrl) {
    if (!productCache[productUrl]) {
      productCache[productUrl] = fetch(productUrl.replace(/\/$/, '') + '.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to load product options');
          return response.json();
        })
        .catch(function (error) {
          delete productCache[productUrl];
          throw error;
        });
    }

    return productCache[productUrl];
  }

  function renderVariantOptions(product, form, modal) {
    var fields = modal.querySelector('[data-variant-fields]');
    var confirmButton = modal.querySelector('[data-variant-confirm]');
    var status = modal.querySelector('[data-variant-status]');
    var options = normalizeProductOptions(product);
    var selects = [];

    fields.replaceChildren();

    options.forEach(function (option, optionIndex) {
      var field = document.createElement('label');
      var label = document.createElement('span');
      var select = document.createElement('select');
      var placeholder = document.createElement('option');

      field.className = 'variant-modal__field';
      label.textContent = option.name;
      placeholder.value = '';
      placeholder.textContent = form.dataset.selectOptionLabel;
      select.appendChild(placeholder);
      select.setAttribute('data-option-index', optionIndex);

      option.values.forEach(function (value) {
        var optionElement = document.createElement('option');
        optionElement.value = value;
        optionElement.textContent = value;
        select.appendChild(optionElement);
      });

      select.addEventListener('change', updateSelectedVariant);
      field.appendChild(label);
      field.appendChild(select);
      fields.appendChild(field);
      selects.push(select);
    });

    status.textContent = form.dataset.selectionRequiredLabel;

    function updateSelectedVariant() {
      var selectedValues = selects.map(function (select) { return select.value; });
      var complete = selectedValues.every(function (value) { return value !== ''; });
      var variant = null;

      if (complete) {
        variant = product.variants.find(function (candidate) {
          return selectedValues.every(function (value, index) {
            return getVariantOption(candidate, index) === value;
          });
        });
      }

      if (!complete) {
        variantPickerState.selectedVariant = null;
        confirmButton.disabled = true;
        status.textContent = form.dataset.selectionRequiredLabel;
        return;
      }

      if (!variant || !variant.available) {
        variantPickerState.selectedVariant = null;
        confirmButton.disabled = true;
        status.textContent = form.dataset.unavailableLabel;
        return;
      }

      variantPickerState.selectedVariant = variant;
      confirmButton.disabled = false;
      status.textContent = variant.title;
    }
  }

  function normalizeProductOptions(product) {
    return (product.options || []).map(function (option, index) {
      var name = typeof option === 'string' ? option : option.name;
      var values = typeof option === 'string' ? [] : (option.values || []).slice();

      if (values.length === 0) {
        product.variants.forEach(function (variant) {
          var value = getVariantOption(variant, index);
          if (value && values.indexOf(value) === -1) values.push(value);
        });
      }

      return { name: name, values: values };
    });
  }

  function getVariantOption(variant, index) {
    if (variant.options && variant.options[index] !== undefined) return variant.options[index];
    return variant['option' + (index + 1)];
  }

  /* ---------- Scene sets and multi-product bundles ---------- */
  function normalizeSetButtonLabel(button) {
    var configuredLabel = (button.dataset.defaultLabel || '').trim();
    var visibleLabel = button.textContent.trim();
    var missingTranslation = /translation missing/i;
    var fallbackLabel = (document.documentElement.lang || '').toLowerCase().indexOf('zh') === 0
      ? '一键加入购物车'
      : 'Add all to cart';
    var resolvedLabel = configuredLabel && !missingTranslation.test(configuredLabel)
      ? configuredLabel
      : (visibleLabel && !missingTranslation.test(visibleLabel) ? visibleLabel : fallbackLabel);

    button.dataset.defaultLabel = resolvedLabel;
    if (!visibleLabel || missingTranslation.test(visibleLabel)) button.textContent = resolvedLabel;
    return resolvedLabel;
  }

  function initSetBuilders() {
    document.querySelectorAll('[data-set-builder]').forEach(function (builder) {
      builder.querySelectorAll('[data-set-select], [data-set-variant], [data-set-quantity]').forEach(function (input) {
        input.addEventListener('change', function () { updateSetBuilder(builder); });
        input.addEventListener('input', function () { updateSetBuilder(builder); });
      });

      builder.querySelectorAll('[data-set-add], [data-set-buy-now]').forEach(function (actionButton) {
        normalizeSetButtonLabel(actionButton);
        actionButton.addEventListener('click', function () {
          addSetToCart(builder, actionButton, actionButton.hasAttribute('data-set-buy-now'));
        });
      });

      updateSetBuilder(builder);
    });

    document.addEventListener('click', function (event) {
      var openButton = event.target.closest('[data-bundle-open]');
      if (openButton) {
        openBundleDialog(openButton.dataset.dialogId, openButton);
        return;
      }

      var closeButton = event.target.closest('[data-bundle-close]');
      if (closeButton) {
        closeBundleDialog(closeButton.closest('[data-bundle-dialog]'));
        return;
      }

      var quickButton = event.target.closest('[data-bundle-quick-add], [data-bundle-buy-now]');
      if (!quickButton) return;

      var dialog = document.getElementById(quickButton.dataset.dialogId);
      if (!dialog) return;
      var buyNow = quickButton.hasAttribute('data-bundle-buy-now');
      var dialogActionButton = dialog.querySelector(buyNow ? '[data-set-buy-now]' : '[data-set-add]');

      if (!dialogActionButton || dialogActionButton.disabled) {
        openBundleDialog(quickButton.dataset.dialogId, quickButton);
        return;
      }

      addSetToCart(dialog, quickButton, buyNow);
    });

    document.querySelectorAll('[data-bundle-dialog]').forEach(function (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeBundleDialog(dialog);
      });
    });
  }

  function openBundleDialog(dialogId, trigger) {
    var dialog = document.getElementById(dialogId);
    if (!dialog) return;
    dialog._bundleTrigger = trigger;
    updateSetBuilder(dialog);

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closeBundleDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    if (dialog._bundleTrigger) dialog._bundleTrigger.focus();
  }

  function selectedSetItems(builder) {
    var items = [];
    var autoInclude = builder.dataset.setAutoInclude === 'true';

    builder.querySelectorAll('[data-set-item]').forEach(function (row) {
      var checkbox = row.querySelector('[data-set-select]');
      if (checkbox && (!checkbox.checked || checkbox.disabled)) return;
      if (!checkbox && !autoInclude) return;
      if (autoInclude && row.dataset.available !== 'true') return;

      var variantSelect = row.querySelector('[data-set-variant]');
      var quantityInput = row.querySelector('[data-set-quantity]');
      var selectedOption = variantSelect ? variantSelect.options[variantSelect.selectedIndex] : null;
      var variantId = variantSelect ? variantSelect.value : row.dataset.variantId;
      var quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);
      var price = selectedOption ? parseInt(selectedOption.dataset.price, 10) : parseInt(row.dataset.price, 10);

      if (!variantId) return;
      items.push({ id: Number(variantId), quantity: quantity, price: price || 0 });
    });

    return items;
  }

  function updateSetBuilder(builder) {
    builder.querySelectorAll('[data-set-item]').forEach(function (row) {
      var checkbox = row.querySelector('[data-set-select]');
      row.classList.toggle('is-selected', Boolean(checkbox && checkbox.checked && !checkbox.disabled));
    });

    var items = selectedSetItems(builder);
    var count = items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
    var total = items.reduce(function (sum, item) { return sum + (item.price * item.quantity); }, 0);
    var countElement = builder.querySelector('[data-set-count]');
    var totalElement = builder.querySelector('[data-set-total]');
    var actionButtons = builder.querySelectorAll('[data-set-add], [data-set-buy-now]');
    var requiresAll = builder.dataset.requireAll === 'true';
    var hasUnavailableItem = requiresAll && builder.querySelector('[data-set-select]:disabled');

    if (countElement) countElement.textContent = count;
    if (totalElement) totalElement.textContent = formatSetMoney(total, builder.dataset.currency);
    actionButtons.forEach(function (actionButton) {
      actionButton.disabled = items.length === 0 || Boolean(hasUnavailableItem);
    });
  }

  function formatSetMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency || 'CNY'
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }

  function addSetToCart(builder, button, buyNow) {
    var items = selectedSetItems(builder);
    var status = builder.querySelector('[data-set-status]');
    var originalLabel = normalizeSetButtonLabel(button);
    var builderButton = builder.querySelector('[data-set-add]');
    var builderActionButtons = Array.from(builder.querySelectorAll('[data-set-add], [data-set-buy-now]'));
    var setName = button.dataset.setName || (builderButton ? builderButton.dataset.setName : '') || '';

    if (items.length === 0) return;

    builderActionButtons.forEach(function (actionButton) { actionButton.disabled = true; });
    button.disabled = true;
    button.textContent = button.dataset.loadingLabel;
    if (status) status.textContent = '';

    var payload = {
      items: items.map(function (item) {
        return {
          id: item.id,
          quantity: item.quantity,
          properties: setName ? { _furballly_set: setName } : {}
        };
      })
    };

    fetch(builder.dataset.addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add set to cart');
        if (buyNow) {
          window.location.assign(builder.dataset.checkoutUrl || '/checkout');
          return null;
        }
        return fetch(builder.dataset.cartUrl, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
      })
      .then(function (response) {
        if (!response) return null;
        if (!response.ok) throw new Error('Unable to refresh cart');
        return response.json();
      })
      .then(function (cart) {
        if (!cart) return;
        updateCartCount(cart.item_count);
        button.textContent = button.dataset.successLabel;
        if (status) status.textContent = button.dataset.successLabel;
      })
      .catch(function (error) {
        console.error(error);
        button.textContent = button.dataset.errorLabel;
        if (status) status.textContent = button.dataset.errorLabel;
      })
      .finally(function () {
        window.setTimeout(function () {
          button.textContent = originalLabel;
          updateSetBuilder(builder);
          if (!button.matches('[data-set-add], [data-set-buy-now]')) button.disabled = false;
        }, 1800);
      });
  }

  function updateCartCount(itemCount) {
    document.querySelectorAll('.cart-link').forEach(function (cartLink) {
      var count = cartLink.querySelector('.cart-count');

      if (itemCount < 1) {
        if (count) count.remove();
        return;
      }

      if (!count) {
        count = document.createElement('span');
        count.className = 'cart-count';
        count.setAttribute('aria-live', 'polite');
        cartLink.appendChild(count);
      }

      count.textContent = itemCount;
    });
  }
})();
